import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnuicecatComponent } from './simple-icons-gnuicecat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnuicecatComponent ],
    exports:      [ SimpleIconsGnuicecatComponent ],
    bootstrap:    []
})
export class SimpleIconsGnuicecatModule {}
